"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwIncludeErrorMessages = void 0;
function findErrorLogs(logs) {
    return logs
        .filter((log) => {
        return log.startsWith('Program log: Error: ');
    })
        .map((log) => log.slice(20));
}
function throwIncludeErrorMessages(e) {
    const logs = findErrorLogs(e.logs ?? []);
    if (logs.length !== 0) {
        e.message = e.message + `. Messages: ${JSON.stringify(logs)}`;
    }
    throw e;
}
exports.throwIncludeErrorMessages = throwIncludeErrorMessages;
//# sourceMappingURL=error-logs.js.map